import { Protocol } from './_types';

export const LIB_PROTOCOL_MACADAMIA_TREE_SCREEN_EVAL: Protocol = {
    id: "macadamia_tree_screen_eval",
    title: "Advanced Macadamia Tree Evaluation",
    description: "Tree Evaluation is performed to characterise the adaptability of cultivars and selections on the base of a full set of tree characteristics and includes all phenological stages. Characteristics such as growth and architecture, flowering and fruit set, pests and diseases and general adaptability are evaluated in detail.",
    sampleType: "plant",

    chars: [
        "date_ivb_nut",
        "date_irb_nut",
        "date_start_flower_nut",
        "date_end_flower_nut",
        "date_set_date",
        "date_kernel_abs",
        "date_harvest_start_nut",
        "date_harvest_end_nut",
        "date_leaf_drop_nut",
        "fsa_bud_break_warm",
        "fsa_bud_break_cool",
        "fsb_raceme_elongation_warm",
        "fsb_raceme_elongation_cool",
        "fsc_pre_flower_warm",
        "fsc_pre_flower_cool",
        "fsd_bud_elongation_warm",
        "fsd_bud_elongation_cool",
        "fse_style_bend_warm",
        "fse_style_bend_cool",
        "fsf_open_flower_warm",
        "fsf_open_flower_cool",
        "fsg_petal_drop_warm",
        "fsg_petal_drop_cool",
        "fsh_nut_swell_warm",
        "fsh_nut_swell_cool",


        "tree_branch_habit_mac",
        "nut_tree_grow_form",
        "tree_grow_potent_mac_f1_pre",
        "tree_grow_potent_mac_f1_post",
        "tree_grow_potent_mac_f2_pre",
        "tree_grow_potent_mac_f2_post",
        "tree_grow_potent_mac_f3_pre",
        "tree_grow_potent_mac_f3_post",
        "tree_grow_potent_mac_f4_pre",
        "tree_grow_potent_mac_f4_post",
        "tree_grow_potent_mac_f5_pre",
        "tree_grow_potent_mac_f5_post",
        "nut_tree_branch_dense",
        "nut_tree_canopy_dense",
        "nut_tree_branch_angle",
        "nut_tree_weather_damage",
        "nut_tree_leaf_colour",

        "nut_tree_plant_system",

        "nut_tree_flower_colour",
        "nut_tree_flower_pos",
        "nut_tree_flower_distrib",
        "nut_tree_multiple_flower",
        "nut_tree_inflorescence_length",
        "nut_tree_inflorescence_cluster",

        "nut_tree_bear_precocity",
        "nut_tree_bear_wood",
        "nut_tree_bear_pos",
        "nut_tree_set_pot",
        "nut_tree_alt_bear",

        "nut_tree_pest_detect",
        "nut_tree_disease_detect",
        "nut_tree_overall_disease",
    ],

    measures: [
        "tree_trunk_circum",
        "tree_trunk_dia",
        "tree_height",
        "skirt_height",
        "tree_nut_drop",
        "tree_nut_set",
    ],

    indexes: [],
}
